import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";


import { ToastContainer } from "react-toastify";
import ProductsOrders from "pages/Dashboards/Ecommerce/ProductsOrders";


const Orders = () => {

    // Get Data
    useEffect(() => {
        //onGetOrders();
        document.body.classList.remove('overflow-hidden');

    }, []);

    return (
        <React.Fragment>
            <BreadCrumb title='Orders' pageTitle='' />
            <ToastContainer closeButton={false} limit={1} />
            <ProductsOrders/>
        </React.Fragment>
    );
};

export default Orders;